import { memo } from "react";

import { BMI_INFO_BY_QUESTION } from "@/constants/bmiInfo";
import { UnitTypes } from "@/constants/bodyMetrics";
import { QUESTIONS_IDS } from "@/constants/questionsIds";
import { useGender } from "@/utils/GenderProvider";
import { convertToKg } from "@/utils/services/weightFormatters";
import useAnswers from "@/utils/useAnswers";

interface BodyMetricLabelProps {
    questionId: QUESTIONS_IDS;
    value: number | null;
    error?: string | null;
}

export const BodyMetricLabel = memo<BodyMetricLabelProps>(({ questionId, value, error }) => {
    const { answers } = useAnswers();
    const { isFemale } = useGender();
    const height = answers[QUESTIONS_IDS.HEIGHT] as number;
    const currentWeight = answers[QUESTIONS_IDS.CURRENT_WEIGHT] as number;
    const units = answers.units as UnitTypes;

    const {
        text,
        title,
        bgColor,
        icon: Icon,
    } = BMI_INFO_BY_QUESTION[questionId as keyof typeof BMI_INFO_BY_QUESTION]({
        value: convertToKg(value ?? 0, units),
        height,
        currentWeight,
        units,
        isFemale,
        error,
    });

    return (
        <div
            className="grid gap-2 rounded-2xl p-4 text-zing-12-18 text-white female:text-black"
            style={{ backgroundColor: bgColor }}
        >
            {title && (
                <div className="flex items-center gap-2">
                    {Icon && <Icon />}
                    <div className="font-semibold">{title}</div>
                </div>
            )}
            <div>{text}</div>
        </div>
    );
});
